angular.module('all').run([ 'CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(
    [ '$log','$rootScope', 'AppRoutes', '_', 'Idle', 'LogOffService','$transitions', 'TransitionManager',
    function ($log, $rootScope, AppRoutes, _, Idle, LogOffService, $transitions, TransitionManager) {

        $rootScope.hideToolbar = true;
        $rootScope.hideHeader = false;

        $transitions.onStart({}, function(transition) {
            var appRoute = _.find(AppRoutes, {state: transition.to().name});
            $rootScope.hideHeader = !!(appRoute && appRoute.portalSettings && appRoute.portalSettings.hideHeader);
            $rootScope.hideFooter = !!(appRoute && appRoute.portalSettings && appRoute.portalSettings.hideFooter);
            $rootScope.loginView = !!(appRoute && appRoute.state && appRoute.state === 'login');
            if (!$rootScope.loginView) {
                $rootScope.$broadcast('IdleStartWatch');
            }
        });

// ng-idle event listeners
// Please see 'modules\app\app.js' for application timeout configuration and documentation.
//
// IdleTimeout - logout logic is implemented here
        $rootScope.$on('IdleTimeout', function () {
            $log.info('Idle timeout has expired.  Logging client out and transitioning to login view.  ' + moment().format('lll'));

            // Has watch() been called and is watching for idleness
            if (Idle.running()) {
                Idle.unwatch();  // stop watching for idleness
            }


            // Call log off service and go back to login view
            LogOffService.logoff().then(function () {
                TransitionManager.transition({appRoute: 'login'});
            });
        });

        // IdleStartWatch - startup logic is implemented here
        $rootScope.$on('IdleStartWatch', function() {
            Idle.watch();  // start watching for idleness.  $broadcast() is located in LoginCtrl.js
        });
    }]);
    }]);